<template>
    <div
        v-if="canShow"
        class="secret-sync-box"
    >
        <div v-if="contactError && syncType !== 'all'">
            <ul class="secret-sync-desc">
                <li>暂无法导入或同步企业微信员工至企点</li>
            </ul>
        </div>
        <div
            v-else
            :class="contactError ? 'secret-sync-disabled' : ''"
        >
            <div v-if="syncType === 'all'">
                <sync-rule
                    :rule-data="ruleData"
                    :read-only="true"
                />
                <div class="secret-sync-btn-box">
                    <a href="/mng/weworkAccount/index/sync/edit">编辑同步规则</a>
                    <!-- <a href="##" class="params-sync-rule-close" @click.prevent="closeSync">关闭同步</a> -->
                </div>
            </div>
            <div v-else-if="syncType === 'manual'">
                <ul class="secret-sync-desc">
                    <li v-if="isOrgInited">
                        可随时导入企业微信员工至企点
                    </li>
                    <li v-else>
                        组织架构拉取完成后（约1分钟），即可导入企业微信员工
                        <a
                            @click.prevent="getSyncConfig"
                            href="javscript:;"
                            class="secret-sync-btn-refresh"
                        >刷新</a>
                    </li>
                </ul>
                <v-button
                    v-if="isOrgInited"
                    @click="jumpImport"
                    status="primary"
                    class="secret-sync-btn"
                >
                    导入企业微信员工
                </v-button>
            </div>
            <div v-else>
                <ul class="secret-sync-desc">
                    <li>可拉取企业微信员工信息</li>
                </ul>
                <v-button
                    @click="syncBtnClick"
                    status="primary"
                    class="secret-sync-btn"
                >
                    同步企业微信员工
                </v-button>
            </div>
        </div>
        <v-button
            v-if="insteadError"
            @click="jumpInsteadPage"
            status="primary"
            class="secret-sync-btn"
        >
            联系企业专员修复
        </v-button>
        <v-button
            v-else-if="contactSecretError"
            @click="showSecretDialog"
            status="primary"
            class="secret-sync-btn"
        >
            立即修正
        </v-button>
        <v-button
            v-else-if="!isNew && !hasContactSecret"
            @click="showSecretDialog"
            status="primary"
            class="secret-sync-btn"
        >
            重新授权
        </v-button>

        <secret-dialog
            ref="secretDialog"
            :has-sync-step="hasSync"
            @success="onAuthSuccess"
        />
        <mobile-validate-dialog
            ref="closeSyncDialog"
            @verify="onMobileVerify"
            confirm-title="关闭企业微信通讯录同步？"
            confirm-btn-txt="关闭同步"
        >
            <div
                slot="content"
                class="close-sync-content"
            >
                关闭同步后，企业微信员工将不会再同步到企点<br>
                关闭前，请前往
                <a
                    @click="externalJump('https://work.weixin.qq.com/wework_admin/frame')"
                    style="cursor: pointer;"
                >
                    企业微信管理后台</a>删除“腾讯企业客服”应用。
                <span>
                    如果要再次开启“完全使用企业微信的通讯录”的同步模<br>式，需要先删除企点组织架构中的所有员工
                </span>
            </div>
        </mobile-validate-dialog>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';
import Gateway from '@/utils/Gateway';
import getSyncConfig from '@/pages/mng/third_account/weworkCombine/api/getSyncConfig';
import getWeworkCorpInfo from '@/pages/mng/third_account/weworkCombine/api/getWeworkCorpInfo';
import getInnerAppAccessToken from '@/pages/mng/third_account/weworkCombine/api/getInnerAppAccessToken';
import getAuthorizeAppResult from '@/pages/mng/third_account/weworkCombine/api/getAuthorizeAppResult';

import SecretDialog from '../../secret-dialog';
import MobileValidateDialog from '../../mobile-validate-dialog';
import SyncRule from '../../sync-rule';

const req = require.context('./assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
    components: {
        SecretDialog,
        MobileValidateDialog,
        SyncRule,
    },

    props: {
        // 是否有同步通讯录能力
        hasSync: {
            type: Boolean,
            default: false,
        },

        // isNew为true走代开发应用模式 否则走通讯录参数模式
        isNew: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            canShow: false,
            secretVal: '',
            hasContactSecret: false,
            contactSecretError: false,
            insteadError: false,
            syncType: '',

            allowSync: false,

            isOrgInited: false,

            hasContactParams: false,
            contactParamsError: false,
            hasSyncRule: false,

            // 同步模式 是否是自动模式
            isAllMode: true,

            // 角色同步类型 是否所有员工使用相同角色
            isAllSameRole: true,

            allSomeRules: [],
            differentRules: [],
            defaultRules: [],
            sendMsgByTel: false,

            hasRuleError: false,
            errType: '',
            errMsg: '',
        };
    },

    computed: {
        syncBtnTxt() {
            if (this.contactParamsError) {
                return '重新同步';
            }

            return '去同步';
        },

        resultTit() {
            return this.isAllMode ? '已完全同步企业微信通讯录至企点' : '通过手动导入将企业微信通讯录同步至企点';
        },

        stepNum() {
            return this.isWeb ? '3' : '2';
        },

        confirmTxt() {
            return this.isWeb ? '下一步' : '同步';
        },

        contactError() {
            return (!this.isNew && !this.hasContactSecret) || this.contactSecretError || this.insteadError;
        },
    },

    created() {
        if (this.isNew) {
            this.getInsteadResult();
        } else {
            this.getContactSecret();
        }
    },

    methods: {
        externalJump(path) {
            window.open(path, '_blank');
        },
        getInsteadResult() {
            getAuthorizeAppResult()
                .then((data) => {
                    const { hasInstall } = data || {};

                    this.insteadError = !hasInstall;

                    if (!hasInstall) {
                        this.statusChange('insteaderror');
                    }

                    this.getSyncConfig();
                })
                .catch(() => {
                    this.insteadError = true;
                    this.statusChange('insteaderror');
                    this.getSyncConfig();
                });
        },

        jumpInsteadPage() {
            this.$router.push('/mng/weworkAccount/index/instead');
        },

        getContactSecret() {
            return getWeworkCorpInfo().then((res) => {
                const { corpSecret, corpId } = res;
                if (corpSecret) {
                    this.secretVal = corpSecret;
                    this.hasContactSecret = true;
                    this.contactSecretValiate(corpId);
                } else {
                    this.hasContactSecret = false;
                    this.canShow = true;
                    this.statusChange('empty');
                }
            });
        },

        contactSecretValiate(corpId) {
            getInnerAppAccessToken(corpId).then((errData) => {
                const { hasError } = errData || {};

                if (hasError) {
                    this.contactSecretError = true;
                    this.canShow = true;
                    this.statusChange('error');
                } else {
                    this.contactSecretError = false;
                }

                this.getSyncConfig();
            });
        },

        getSyncConfig() {
            return getSyncConfig()
                .then((res) => {
                    const {
                        hasSyncRule,
                        syncMode,
                        allowSync,
                        isOrgInited,
                        syncType,
                        syncRule,
                        defaultRoles,
                        isAllSameRole,
                        isSendMsg,
                    } = res;

                    this.syncType = syncType;
                    this.hasSyncRule = hasSyncRule;
                    this.isAllMode = syncMode === 1;
                    this.ruleData = res;
                    this.allowSync = allowSync;
                    this.isOrgInited = isOrgInited;

                    this.isAllSameRole = isAllSameRole;
                    if (isAllSameRole) {
                        this.allSomeRules = defaultRoles;
                    } else {
                        this.defaultRules = defaultRoles;
                        this.differentRules = syncRule.map((item) => {
                            let deps = [];

                            if (item.deps && item.deps.length) {
                                deps = item.deps.map(d => ({
                                    id: d.dep_id,
                                    name: d.dep_name,
                                }));
                            }

                            return { ...item, deps };
                        });
                    }

                    this.sendMsgByTel = isSendMsg;

                    this.canShow = true;

                    // local, manual, all
                    if (!this.contactError) {
                        this.statusChange(syncType);
                    }
                })
                .catch(() => {
                    this.canShow = true;
                });
        },

        showSecretDialog() {
            this.$refs.secretDialog.show(this.secretVal);
        },

        onAuthSuccess() {
            this.getContactSecret();
        },

        // 关闭同步
        closeSync() {
            this.$refs.closeSyncDialog.showConfirm();
        },

        onMobileVerify(code) {
            this.$refs.closeSyncDialog.showVerifyLoading();
            Gateway.post('/v1/wework/SetSyncStatus', { sync_status: 1, verify_code: code })
                .then(() => {
                    this.$message.success('关闭同步成功');
                    this.$refs.closeSyncDialog.hideVerify();
                    this.getSyncConfig();
                })
                .catch((message) => {
                    this.errMsg = message || '关闭同步失败';
                    this.$message.success(this.errMsg);
                    this.showVerifyError(this.errMsg);
                    this.$refs.closeSyncDialog.hideVerifyLoading();
                });
        },

        jumpImport() {
            window.open('/mng/org/importStaff');
        },

        syncBtnClick() {
            if (this.hasSync) {
                this.jumpSyncRule();
            } else {
                Gateway.post('/v1/wework/AddSyncConfig', {
                    sync_mode: 2,
                })
                    .then(() => {
                        this.getSyncConfig();
                        this.$message.success('同步配置成功');
                    })
                    .catch((message) => {
                        this.$message.error(message || '同步配置失败');
                    });
            }
        },

        jumpSyncRule() {
            this.$router.push('/mng/weworkAccount/index/sync/add');
        },

        statusChange(status) {
            let contactStatusTxt = '';

            switch (status) {
            case 'empty':
                contactStatusTxt = '通讯录授权已解除，重新授权后可获取企微通讯录';
                break;
            case 'insteaderror':
                contactStatusTxt = '通讯录授权出错，请联系企点专员重新配置代开发应用';
                break;
            case 'error':
                contactStatusTxt = '通讯录参数错误，请尽快修正';
                break;
            case 'manual':
                contactStatusTxt = '已获取企业微信通讯录授权';
                break;
            case 'all':
                contactStatusTxt = '已获取企业微信通讯录授权，并已完全同步企业微信通讯录至企点';
                break;
            default:
                contactStatusTxt = '已获取企业微信通讯录授权，如果需要同步企业微信员工到企点，请点击下方按钮配置';
            }

            this.$emit('statusChange', { status, hasContactError: this.contactError, contactStatusTxt });
        },
    },
};
</script>
<style scoped lang="less">
@import './secret-sync-rule.less';
</style>
